export default __webpack_public_path__ + "static/media/logout-icon.5df02ba8.svg";